export default __webpack_public_path__ + "static/media/thunderstorm-day.9268f922.svg";